export default __webpack_public_path__ + "static/media/slider_02-25_eng_mod_2.77782208.png";